import React, { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  WizardSidebarWrapper,
  WrapperGroup,
  PanelHeaderWrapper,
  OptionWrapper,
  OptionItem,
  Icon,
  UsefullNumericalInputWrapper,
  CrossSectionSelection,
  LineSettingWrapperStyled,
  LineTypeSelectorWrapperStyled,
  LineTypeSelectorStyled,
  LineTypeSelectorTabStyled,
} from './styles';
import { Label, UnitsLabel } from '@/components/SideMenu/styles';

import UsefullNumericSizeInput from '@/components/NumericInput/UsefullNumericSizeInput';
import CircleRadioButton from '@/components/CircleRadioButton';
import InlineButtonsGroup from '@/components/InlineButtonsGroup';
import CheckButton from '@/components/CheckButton';

import VerticalIcon from '@/icons/wizard/v.svg';
import VerticalIconActive from '@/icons/wizard/v-active.svg';
import ExpandIcon from '@/icons/wizard/expand.svg';
import HorizontalIcon from '@/icons/wizard/h.svg';
import HorizontalIconActive from '@/icons/wizard/h-active.svg';
import VerticalHorizontalIcon from '@/icons/wizard/vh.svg';
import VerticalHorizontalIconActive from '@/icons/wizard/vh-active.svg';
import NormalIcon from '@/icons/wizard/n.svg';
import NormalIconActive from '@/icons/wizard/n-active.svg';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import DashedLineIcon from '@/icons/wizard/dashed-line.svg';
import SolidLineIcon from '@/icons/wizard/solid-line.svg';

const WizardSidebar = props => {
  const {
    title,
    isDesktop,
    targetDevice,
    isSmartphone,
    userSizeUnit,
    withMiddleLine,
    setWithMiddleLine,
    lineType,
    setLineType,
    lineThickness,
    onLineThicknessChangeClb,
    isDimesionTypeDiameter,
    setIsDimesionTypeDiameter,
    isFlagLengthAuto,
    setIsFlagLengthAuto,
    textOrientation,
    setTextOrientation,
    cableDiameter,
    flagLength,
    onCableDiameterChangeClb,
    onFlagLengthChangeClb,
    slaveAngle,
    setSlaveAngle,
    crossSectionAreas,
    crossSelectedSection,
    setCrossSelectedSection,
    setCableDiameterByArea,
    isCableFlagSync,
    setIsCableFlagSync,
    setFlagMidLength,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClose = item => {
    setCrossSelectedSection(item);
    setCableDiameterByArea(item.value);
    setAnchorEl(null);
  };

  const orientations = useMemo(
    () => [
      {
        icon: (
          <FormattedMessage
            id="app.editor.sideMenu.expansionPanel.uploadImage.horizontal"
            defaultMessage="Horizontal"
          />
        ),
        selected: textOrientation === 'horizontal',
        onClick: () => setTextOrientation('horizontal'),
      },
      {
        icon: (
          <FormattedMessage
            id="app.editor.sideMenu.expansionPanel.uploadImage.vertical"
            defaultMessage="Vertical"
          />
        ),
        selected: textOrientation === 'vertical',
        onClick: () => setTextOrientation('vertical'),
      },
    ],
    [textOrientation]
  );

  const textFormats = useMemo(
    () => [
      {
        icon: (
          <Icon
            src={
              slaveAngle === 0 && isCableFlagSync
                ? NormalIconActive
                : NormalIcon
            }
          />
        ),
        selected: slaveAngle === 0 && isCableFlagSync,
        onClick: () => {
          setSlaveAngle(0), setIsCableFlagSync(true);
        },
      },
      {
        icon: (
          <Icon
            src={
              slaveAngle === 180 && isCableFlagSync
                ? VerticalIconActive
                : VerticalIcon
            }
          />
        ),
        selected: slaveAngle === 180 && isCableFlagSync,
        onClick: () => {
          setSlaveAngle(180), setIsCableFlagSync(true);
        },
      },
      {
        icon: (
          <Icon
            src={
              slaveAngle === 0 && !isCableFlagSync
                ? HorizontalIconActive
                : HorizontalIcon
            }
          />
        ),
        selected: slaveAngle === 0 && !isCableFlagSync,
        onClick: () => {
          setSlaveAngle(0), setIsCableFlagSync(false);
        },
      },
      {
        icon: (
          <Icon
            src={
              slaveAngle === 180 && !isCableFlagSync
                ? VerticalHorizontalIconActive
                : VerticalHorizontalIcon
            }
          />
        ),
        selected: slaveAngle === 180 && !isCableFlagSync,
        onClick: () => {
          setSlaveAngle(180), setIsCableFlagSync(false);
        },
      },
    ],
    [slaveAngle, isCableFlagSync]
  );

  const handleTypeOfDimensionChange = isDimesionTypeDiameter => {
    if (isDimesionTypeDiameter) {
      setIsDimesionTypeDiameter(true);
      setFlagMidLength(Math.ceil(cableDiameter * Math.PI));
    } else {
      setIsDimesionTypeDiameter(false);
      setCableDiameterByArea(crossSelectedSection.value);
    }
  };

  const handleLineThicknessChange = ev => {
    onLineThicknessChangeClb(ev);
  };

  return (
    <WizardSidebarWrapper>
      <WrapperGroup gridTemplateRows="25px 40px 50px" marginBottom="30px">
        <Label>
          <FormattedMessage
            id="app.editor.wizard.form.typeOfDimension"
            defaultMessage="Type of dimension"
          />
        </Label>
        <OptionWrapper>
          <OptionItem onClick={handleTypeOfDimensionChange.bind(null, true)}>
            <CircleRadioButton selected={isDimesionTypeDiameter} />
            <Label>
              <FormattedMessage
                id="app.editor.wizard.form.diameter"
                defaultMessage="Diameter"
              />
            </Label>
          </OptionItem>
          <OptionItem onClick={handleTypeOfDimensionChange.bind(null, false)}>
            <CircleRadioButton selected={!isDimesionTypeDiameter} />
            <Label>
              <FormattedMessage
                id="app.editor.wizard.form.crossSection"
                defaultMessage="Cross section"
              />
            </Label>
          </OptionItem>
        </OptionWrapper>
        {isDimesionTypeDiameter && (
          <UsefullNumericalInputWrapper>
            <UsefullNumericSizeInput
              backgroundColor={'white'}
              borderRadius={'4px'}
              onChange={ev => onCableDiameterChangeClb(ev)}
              value={cableDiameter}
              units={userSizeUnit}
              stepMm={0.1}
              minval={0.1}
            />
            <UnitsLabel style={{ marginLeft: '10px' }}>
              <FormattedMessage
                id={`app.sizeUnits.${userSizeUnit}`}
                defaultMessage={userSizeUnit}
              />
            </UnitsLabel>
          </UsefullNumericalInputWrapper>
        )}
        {!isDimesionTypeDiameter && (
          <UsefullNumericalInputWrapper>
            <CrossSectionSelection
              id="cross-section-selection"
              aria-controls={anchorEl ? 'cross-section-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={anchorEl ? 'true' : undefined}
              onClick={e => setAnchorEl(e.currentTarget)}
            >
              {crossSelectedSection.label}
              <Icon src={ExpandIcon}></Icon>
            </CrossSectionSelection>
            <Menu
              id="cross-section-menu"
              aria-labelledby="cross-section-selection"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              PaperProps={
                isSmartphone
                  ? {}
                  : {
                      style: {
                        maxHeight: '50vh',
                        marginLeft: -175,
                      },
                    }
              }
            >
              {crossSectionAreas?.map(item => {
                return (
                  <MenuItem
                    onClick={() => handleClose(item)}
                    key={item.label}
                    selected={item.label === crossSelectedSection.label}
                  >
                    {item.label}
                  </MenuItem>
                );
              })}
            </Menu>
          </UsefullNumericalInputWrapper>
        )}
      </WrapperGroup>

      <WrapperGroup gridTemplateRows="25px 40px 50px" marginBottom="20px">
        <Label>
          <FormattedMessage
            id="app.editor.wizard.form.flagLength"
            defaultMessage="Flag length"
          />
        </Label>
        <OptionWrapper>
          <OptionItem onClick={() => setIsFlagLengthAuto(false)}>
            <CircleRadioButton selected={!isFlagLengthAuto} />
            <Label>
              <FormattedMessage
                id="app.editor.wizard.form.setManually"
                defaultMessage="Set manually"
              />
            </Label>
          </OptionItem>
          <OptionItem onClick={() => setIsFlagLengthAuto(true)}>
            <CircleRadioButton selected={isFlagLengthAuto} />
            <Label>
              <FormattedMessage
                id="app.editor.wizard.form.auto"
                defaultMessage="Auto"
              />
            </Label>
          </OptionItem>
        </OptionWrapper>
        <UsefullNumericalInputWrapper>
          <UsefullNumericSizeInput
            backgroundColor={'white'}
            borderRadius={'4px'}
            onChange={ev => onFlagLengthChangeClb(ev)}
            value={flagLength}
            units={userSizeUnit}
            stepMm={0.1}
            minval={0.1}
            disabled={isFlagLengthAuto}
          />
          <UnitsLabel style={{ marginLeft: '10px' }}>
            <FormattedMessage
              id={`app.sizeUnits.${userSizeUnit}`}
              defaultMessage={userSizeUnit}
            />
          </UnitsLabel>
        </UsefullNumericalInputWrapper>
      </WrapperGroup>

      <WrapperGroup gridTemplateRows="45px" marginBottom="30px">
        <PanelHeaderWrapper onClick={() => setWithMiddleLine(!withMiddleLine)}>
          <CheckButton checked={withMiddleLine} />
          <FormattedMessage
            id="app.editor.wizard.form.centeredLine"
            defaultMessage="Centered line"
          />
        </PanelHeaderWrapper>

        {withMiddleLine && (
          <>
            <LineSettingWrapperStyled>
              <Label marginBottom="10px">
                <FormattedMessage
                  id="app.editor.wizard.form.lineType"
                  defaultMessage="Line type"
                />
              </Label>
              <LineTypeSelectorWrapperStyled>
                <LineTypeSelectorStyled>
                  <LineTypeSelectorTabStyled
                    active={lineType === 'dashed'}
                    onClick={setLineType.bind(null, 'dashed')}
                  >
                    <Icon src={DashedLineIcon} width="20px" height="20px" />
                  </LineTypeSelectorTabStyled>
                  <LineTypeSelectorTabStyled
                    active={lineType === 'solid'}
                    onClick={setLineType.bind(null, 'solid')}
                  >
                    <Icon src={SolidLineIcon} width="20px" height="20px" />
                  </LineTypeSelectorTabStyled>
                </LineTypeSelectorStyled>
              </LineTypeSelectorWrapperStyled>
            </LineSettingWrapperStyled>
            <LineSettingWrapperStyled>
              <Label marginBottom="10px">
                <FormattedMessage
                  id="app.editor.wizard.form.lineThickness"
                  defaultMessage="Line thickness"
                />
              </Label>
              <div style={{ height: '50px' }}>
                <UsefullNumericalInputWrapper>
                  <UsefullNumericSizeInput
                    backgroundColor={'white'}
                    borderRadius={'4px'}
                    onChange={handleLineThicknessChange}
                    value={lineThickness}
                    units={userSizeUnit}
                    stepMm={0.1}
                    minval={0.1}
                  />
                  <UnitsLabel style={{ marginLeft: '10px' }}>
                    <FormattedMessage
                      id={`app.sizeUnits.${userSizeUnit}`}
                      defaultMessage={userSizeUnit}
                    />
                  </UnitsLabel>
                </UsefullNumericalInputWrapper>
              </div>
            </LineSettingWrapperStyled>
          </>
        )}
      </WrapperGroup>

      <WrapperGroup gridTemplateRows="25px 45px" marginBottom="30px">
        <Label>
          <FormattedMessage
            id="app.editor.wizard.form.textOrientation"
            defaultMessage="Text orientation"
          />
        </Label>
        <InlineButtonsGroup items={orientations} />
      </WrapperGroup>

      <WrapperGroup gridTemplateRows="25px 45px" marginBottom="30px">
        <Label>
          <FormattedMessage
            id="app.editor.wizard.form.textFormat"
            defaultMessage="Text format"
          />
        </Label>
        <InlineButtonsGroup items={textFormats} />
      </WrapperGroup>
    </WizardSidebarWrapper>
  );
};

export default React.memo(WizardSidebar);
